import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { categoryProps } from 'src/app/interfaces/iresponse';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';
import { UtilService } from 'src/app/services/utilService/util.service';
import { genderType } from 'src/app/users/enrol-riders/enrol-riders.component';

@Component({
  selector: 'app-manage-categories',
  templateUrl: './manage-categories.component.html',
  styleUrl: './manage-categories.component.css'
})
export class ManageCategoriesComponent implements OnInit {
  constructor(private utilService: UtilService, private userService: UserService){}
  breadCrumb: any;
  changeOccured:boolean = true;
  loadingData: boolean = false;
  toggled:boolean = false;
  deleting:boolean = false;
  submitting:boolean = false;
  categoryId: number = 0;
  categories: Array<categoryProps> = [];

  categoryForm = new FormGroup({
    name: new FormControl('', Validators.required),
    daily_fee: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]),
    enrollment_fee: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)])
  })

  filters:Array<genderType> = [
    {id: 1, value: '', name: 'Filter category'},
    {id: 2, value: 'active', name: 'Active'},
    {id: 3, value: 'inactive', name: 'InActive'},
  ];

  filterForm = new FormGroup({
    status: new FormControl('', Validators.required)
  })
  addCategory(){
    this.utilService.openModal('categoryModal');
  }
  ngOnInit(): void {
    this.getCategory();
    this.breadCrumb  = {
      name: 'Manage Categories',
      parent: 'Settings',
      subLink: null
    };
  }
  getCategory(){
    this.loadingData = true;
    this.changeOccured = false;
    const filterValue = this.filterForm.get('status').value;
    this.userService.getCategories(filterValue).subscribe({
      next: (response)=>{
        this.changeOccured = true;
        this.utilService.startDatatable('categories')
        this.categories = response;
      },
      error: (err)=>{
        this.changeOccured = true;
        this.utilService.startDatatable('categories');
      }
    }).add(()=> this.loadingData = false)
  }


  addCategoryForm(){
    if(this.categoryForm.invalid){
      return;
    }
    this.submitting = true;
    this.userService.postCategory(this.categoryForm.value).subscribe({
      next:(response)=>{
        this.categoryForm.reset();
        this.getCategory();
        this.utilService.closeModal('categoryModal');
      },
      error: (error)=>{
        this.submitting = false;
      }
    }).add(()=>this.submitting = false);
  }

  deleteCategory(id: number){
    this.deleting = true;
    return this.userService.deleteCategory(id).subscribe({
      next: (response)=>{
        this.getCategory();
      }
    }).add(() => this.deleting = false)
  }


  onFilterBy(){
    if(this.filterForm.invalid) return;
    this.getCategory();
  }

  toggleAgentStatus(id: number, status: string){
    this.categoryId = id;
    this.toggled = true;
    this.utilService.confirmAction(()=>{
      this.userService.toggleCategory({category_id: id, action: status}).subscribe({
        next:(response)=>{
          this.getCategory();
        }
      }).add(()=> this.toggled = false)
    }, ()=>{
      this.toggled = false
    })
  }
}
